// extracted by mini-css-extract-plugin
export default {"login":"style_login__1XtN6","title":"style_title__6PHZs","block":"style_block__X+rTQ","inner":"style_inner__2eZkG","form":"style_form__xCzb1"};